import React, {Component} from 'react';
// import Select from 'react-select';
import GridContainer from "../material-pro/Grid/GridContainer";
import GridItem from "../material-pro/Grid/GridItem";
import reduxFieldStyles from "../../assets/jss/reduxFields/ReduxField";
import withStyles from "@material-ui/core/es/styles/withStyles";
import FormControl from "@material-ui/core/es/FormControl/FormControl";
import FormLabel from "@material-ui/core/es/FormLabel/FormLabel";
import Grow from "@material-ui/core/es/Grow/Grow";
import FormHelperText from "@material-ui/core/es/FormHelperText/FormHelperText";
import InputLabel from "@material-ui/core/es/InputLabel/InputLabel";
// import 'react-select/dist/react-select.css'
import 'react-virtualized/styles.css'
import 'react-virtualized-select/styles.css'
import VirtualizedSelect from 'react-virtualized-select'


const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
      height: "180px",
      zIndex: '2'
    }),
    menuList: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
      height: "180px",
      zIndex: '2'
    }),
    control: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
      height: "56px"
    })
  };


class ReduxSearchableSelectField extends Component {

    render() {
        const {label, input, meta, options, placeholder, classes, disabled} = this.props;
        let newInput = { value: input.value, label: input.value }
        return (
            <FormControl error={meta.error && meta.touched} fullWidth>
                <GridContainer>
                    {label &&
                    <GridItem xs={12} sm={2}>
                        <FormLabel className={classes.labelHorizontal}>
                            {label}
                        </FormLabel>
                    </GridItem>}
                    <GridItem xs={12} sm={label ? 10 : 12}>
                        {/* {input.value &&
                        <InputLabel shrink htmlFor="select-label"
                        className="select-input-label">
                            {placeholder}
                        </InputLabel>} */}
                        {/* <Select
                            id="select-label"
                            classNamePrefix="react-select"
                            {...this.props}
                            isClearable={true}
                            isSearchable
                            styles={customStyles}
                            placeholder={placeholder}
                            defaultValue={newInput}
                            onChange={(value) => input.onChange(value.value)}
                            onBlur={(value) => input.onBlur(value.value)}
                            options={options}
                            isDisabled={disabled}
                        /> */}
                        <VirtualizedSelect
                            id="select-label"
                            options={options}
                            classNamePrefix="react-select"
                            onChange={(value) => input.onChange(value.value)}
                            value={newInput.value}
                            clearable={false}
                            disabled={disabled}
                            placeholder={placeholder}
                        />
                        {meta.error && meta.touched &&
                        <Grow in={meta.error && meta.touched}>
                            <FormHelperText>{meta.error}</FormHelperText>
                        </Grow>}
                    </GridItem>
                </GridContainer>
            </FormControl>
        );
    }
}

export default withStyles(reduxFieldStyles)(ReduxSearchableSelectField)


// WEBPACK FOOTER //
// ./src/components/reduxFields/ReduxSearchableSelectField.js